export type PlaceholderDto = {
  label: string;
  value: string | PlaceholderModel[];
  type?: string;
};

export type PlaceholderModel = PlaceholderDto;

export function mapPlaceholderDtoToModel(dto: PlaceholderDto): PlaceholderModel {
  return {
    type: dto.type ? dto.type : null,
    label: dto.label,
    value: Array.isArray(dto.value) ? dto.value.map(mapPlaceholderDtoToModel) : dto.value,
  };
}

export const PlaceholderType = {
  Survey: 'survey',
  Employee: 'employee',
  Department: 'department',
  Demographics: 'demographics',
  CompanyName: 'company-name',
};
